export default "__VITE_ASSET__c3ff3312__"